import { render, staticRenderFns } from "./c_goods.vue?vue&type=template&id=4d1fe738&scoped=true&"
import script from "./c_goods.vue?vue&type=script&lang=js&"
export * from "./c_goods.vue?vue&type=script&lang=js&"
import style0 from "./c_goods.vue?vue&type=style&index=0&id=4d1fe738&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1fe738",
  null
  
)

export default component.exports